<template>
  <div>
    <el-card class="box-card" body-style="min-height:74vh;">
      <div slot="header" class="clearfix">
        <div @click="backPage" class="mt-racede-fff-back flex-row-align">
          <i class="el-icon-arrow-left"></i>返回
        </div>
      </div>
      <div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="190px" size="small" class="demo-ruleForm">
          <el-form-item label="自提点名称：" prop="pickupName">
            <el-input style="width: 424px;" v-model="ruleForm.pickupName" placeholder="请输入自提点名称"></el-input>
          </el-form-item>
          <el-form-item label="详情地址：" prop="detail">
            <el-input style="width: 424px;" v-model="ruleForm.detail" placeholder="请输入详情地址"></el-input>
          </el-form-item>
          <el-form-item label="经度：" prop="longitude">
            <el-input style="width: 424px;" v-model="ruleForm.longitude" placeholder="请输入经度"></el-input>
            <a class="color-theme" style="display: inline-block;" href="https://lbs.qq.com/tool/getpoint/index.html" target="_blank">点击获取</a>
          </el-form-item>
          <el-form-item label="纬度：" prop="latitude">
            <el-input style="width: 424px;" v-model="ruleForm.latitude" placeholder="请输入纬度"></el-input>
          </el-form-item>
          <el-form-item label="联系电话：" prop="phone">
            <el-input style="width: 424px;" v-model="ruleForm.phone" placeholder="请输入联系电话"></el-input>
          </el-form-item>
          <el-form-item label="是否开启：" prop="status">
            <el-switch
              v-model="ruleForm.status"
              active-color="#1890FF"
              inactive-color="#CCCCCC">
            </el-switch>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="medium" @click="saveBtn">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { pickupAdd, pickupInfo, pickupEdit } from '@/api/setting'
export default {
  name: 'PickupAdd',
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      token:this.$token,
      dataId: this.$route.query.dataId,
      ruleForm: {
        pickupName:'',
        phone:'',
        detail:'',
        longitude:'',
        latitude:'',
        status: false
      },
      rules: {
        pickupName: [
          { required: true, message: '请输入自提点名称', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' }
        ],
        detail: [
          { required: true, message: '请输入详情地址', trigger: 'blur' }
        ],
        longitude: [
          { required: true, message: '请输入经度', trigger: 'blur' }
        ],
        latitude: [
          { required: true, message: '请输入纬度', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    if (this.$route.query.dataId === undefined || this.$route.query.dataId === 'undefined') {
      this.dataId = ''
    } else {
      let that = this
      pickupInfo({ id: that.dataId }).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.ruleForm.pickupName = data.pickupName
          let status = false
          if (data.status === 1) {
            status = true
          }
          that.ruleForm.status = status
          that.ruleForm.phone = data.phone
          that.ruleForm.detail = data.detail
          that.ruleForm.longitude = data.longitude
          that.ruleForm.latitude = data.latitude
        }
      })
    }
  },
  methods: {
    // 返回上一页
    backPage () {
      this.$router.go(-1)
    },
    // 保存操作
    saveBtn () {
      let that = this
      let dataId = that.dataId
      let pickupName = that.ruleForm.pickupName
      let detail = that.ruleForm.detail
      let phone = that.ruleForm.phone
      let longitude = that.ruleForm.longitude
      var latitude = that.ruleForm.latitude
      let status = that.ruleForm.status ? 1 : 0
      if (pickupName === '') {
        this.$message.error('请输入自提点名称')
        return false
      }
      if (detail === '') {
        this.$message.error('请输入详情地址')
        return false
      }
      if (longitude === '') {
        this.$message.error('请输入经度')
        return false
      }
      if (latitude == '') {
        this.$message.error('请输入纬度')
        return false
      }
      if (phone == '') {
        this.$message.error('请输入联系电话')
        return false
      }
      let passData = {
        pickupName: pickupName, phone: phone, status: status, longitude: longitude, latitude: latitude, detail: detail
      }
      if (dataId !== '') {
        passData = {
          id: dataId, pickupName: pickupName, phone: phone, status: status, longitude: longitude, latitude: latitude, detail: detail
        }
        pickupEdit(passData).then((res) => {
          that.backDataFun(res)
        })
      }else{
        pickupAdd(passData).then((res) => {
         that.backDataFun(res)
        })
      }
    },
    backDataFun(res){
      var that = this
      if (res.errorCode === '0000') {
        this.$message({
          message: res.msg,
          type: 'success',
          onClose () {
            that.$router.go(-1)
          }
        })
      }
      if (res.errorCode === '1001') {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/setting/PickupAdd.vue